import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  data: function () {
    return {
      visible: false,
      colorError: false,
      colorSuccess: false,
      colorLoading: false,
      animationOn: false,
      notLoading: false,
    };
  },
})
export default class LoadingPhases extends Vue {
  private msg = "";
  private icon = "";
  private prefix = "";
  private static instance: LoadingPhases;
  private static SUCCESS = 0;
  private static LOADING = 1;
  private static ERROR = 2;
  private static globalstatus: number;
  mobile = Boolean(sessionStorage.getItem("MOBILE"));
  homeLayout = String(sessionStorage.getItem("HOME_LAYOUT"));

  mounted() {
    if (sessionStorage.getItem("MOBILE") == "false") {
      this.mobile = false;
    }
    LoadingPhases.instance = this;
  }

  exitLoading() {
    if (sessionStorage.getItem("PROVIDER")) {
      setTimeout(function () {
        LoadingPhases.instance.$data.visible = false;
      }, 2000);
      sessionStorage.removeItem("PROVIDER");
    } else if (sessionStorage.getItem("BAG") == "true") {
      LoadingPhases.instance.$data.visible = false;
      this.$router.replace("Pedido");
    } else if (sessionStorage.getItem("MOBILE")) {
      this.blockTouch();
    } else {
      if (!LoadingPhases.instance.$data.colorLoading) {
        LoadingPhases.instance.$data.visible = false;
        if (LoadingPhases.globalstatus == LoadingPhases.SUCCESS) {
          this.$router.replace("HomeFeed");
        }
      }
    }
  }

  blockTouch() {
    $("body").css("pointer-events", "none");
    $("html").css("pointer-events", "none");
  }

  unblockTouch() {
    $("body").css("pointer-events", "auto");
    $("html").css("pointer-events", "auto");
  }

  public static start(changeTo: number, message: string) {
    LoadingPhases.changeContent(changeTo, message);
    LoadingPhases.instance.$data.visible = true;
  }

  public static stop(e?: Event) {
    if (e) e.stopPropagation();
    LoadingPhases.instance.$data.visible = false;
  }

  public static changeContent(changeTo: number, message: string) {
    const status: number = changeTo;
    LoadingPhases.instance.msg = message;
    LoadingPhases.globalstatus = status;

    //Success:
    if (status == LoadingPhases.SUCCESS) {
      LoadingPhases.instance.icon = "check-circle";
      LoadingPhases.instance.prefix = "fas";
      LoadingPhases.instance.$data.animationOn = false;
      LoadingPhases.instance.$data.colorSuccess = true;
      LoadingPhases.instance.$data.colorLoading = false;
      LoadingPhases.instance.$data.colorError = false;
      LoadingPhases.instance.$data.notLoading = true;
      //Loading
    } else if (status == LoadingPhases.LOADING) {
      LoadingPhases.instance.icon = "spinner";
      LoadingPhases.instance.prefix = "fas";
      LoadingPhases.instance.$data.animationOn = true;
      LoadingPhases.instance.$data.colorSuccess = false;
      LoadingPhases.instance.$data.colorLoading = true;
      LoadingPhases.instance.$data.colorError = false;
      LoadingPhases.instance.$data.notLoading = false;
      //Error
    } else if (status == LoadingPhases.ERROR) {
      LoadingPhases.instance.icon = "exclamation-circle";
      LoadingPhases.instance.prefix = "far";
      LoadingPhases.instance.$data.animationOn = false;
      LoadingPhases.instance.$data.colorSuccess = false;
      LoadingPhases.instance.$data.colorLoading = false;
      LoadingPhases.instance.$data.colorError = true;
      LoadingPhases.instance.$data.notLoading = true;
    }
  }
}
